query CountryAccessesSelect {
  countryAccesses(page: 0, rowsPerPage: 1000) {
    nodes {
      id
      title
      isDefault
    }
  }
}
